export default "__VITE_ASSET__e3ebc64b__"